/* eslint-disable no-underscore-dangle */
import videojs from 'video.js';

const Component = videojs.getComponent('Component');

class CustomProgressControl extends Component {
  createEl() {
    const el = super.createEl('div', {
      className: 'vjs-progress-control-container',
    });

    return el;
  }
}

CustomProgressControl.prototype.options_ = {
  children: ['progressControl'],
};

export default CustomProgressControl;
